import React, { FC } from "react";
import Heading from "components/Heading/Heading";

export interface SectionWhoWeAreProps {
  className?: string;
}

const SectionWhoWeAre: FC<SectionWhoWeAreProps> = ({ className = "" }) => {
  return (
    <div className={`nc-SectionWhoWeAre relative ${className}`}>
      <div className="bg-blue-50 dark:bg-blue-100 p-8 rounded-3xl max-w-4xl mx-auto">
        <Heading
          isCenter
          desc=""
          className={"dark:text-blue-950"}
        >
          Who We Are
        </Heading>

        <div className="mt-8 max-w-4xl mx-auto">
          <div className="text-base md:text-lg text-neutral-500  space-y-6">
            <p>
              We're your car's new best friend—on wheels! At Schoon, we bring high-quality, eco-friendly car wash and detailing services right to where you are—parking garages, office buildings, apartments, you name it. We know life gets busy, and finding time for a car wash is the last thing on your to-do list. That's why we come to you!
            </p>
            <p>
              Our team of detail-obsessed pros makes it easy to keep your car looking fresh without wasting water or sitting in line at a traditional car wash. We're all about convenience, quality, and helping the planet while we're at it.
            </p>
            <p>
              Think of us as the modern way to care for your car—zero hassle, zero guilt, and a whole lot of shine!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionWhoWeAre;
